import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const addRegsiterCompany = (data) => {
  return httpClient.post(server.REGISTER_COMPANY + `/`, data);
};
export const checkVerifyEmail = (data) => {
  return httpClient.post(server.REGISTER_COMPANY + `/email-verify`, data);
};

// ⭐ ใหม่: ดึงรายการ group menu ของบริษัทต้นแบบ (Master Template)
// ใช้แสดงเป็น checkbox ให้ผู้ใช้เลือกตอนสร้างบริษัทใหม่ (New company)
export const getRegisterCompanyMasterTemplate = () => {
  return httpClient.get(server.REGISTER_COMPANY + `/master-template`);
};

export const updateRegisterCompany = (companyId, data) => {
  return httpClient.put(server.REGISTER_COMPANY + `/${companyId}`, data);
};